export const CSS_CLASS_BLOCK_NAME = 'bb-sport-selection';
export const SYMBOL_SECTION_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__symbol-section`;
export const DETAILS_SECTION_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__details-section`;
export const SELECTION_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__selection`;
export const STATUS_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__status`;
export const STATUS_INPLAY_CSS_CLASS_MODIFIER = `${STATUS_CSS_CLASS_BLOCK_NAME}--inplay`;
export const STATUS_LABEL_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__status-label`;
export const SELECTION_NAME_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__selection-name`;
export const MARKET_NAME_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__market-name`;
export const EVENT_NAME_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__event-name`;
export const EXTRA_INFO_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__extra-info`;
export const JOCKEY_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__jockey`;
export const TRAINER_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__trainer`;
export const DETAILS_LABEL_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__details-label`;
export const DETAILS_VALUE_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__details-value`;
export const TEXT_CSS_CLASS_BLOCK_NAME = `${CSS_CLASS_BLOCK_NAME}__text`;
export const I18N_JOCKEY_LABEL_TEXT = 'racing.jockey_abbr';
export const I18N_TRAINER_LABEL_TEXT = 'racing.trainer_abbr';
export const I18N_INPLAY_STATUS_TEXT = 'racing.live';
export const GTM_ACTION_BET_CARD = 'bet-card';
